import { KeyboardEvent, useEffect, useRef } from 'react';

export function GenerationStartDialog({ pending, replay, confirm, close }: { pending: boolean; replay: boolean; confirm: () => void; close: () => void }) {
  const root = useRef<HTMLDivElement>(null);
  const cancelButton = useRef<HTMLButtonElement>(null);
  const confirmButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const trigger = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    cancelButton.current?.focus();
    const containFocus = (event: FocusEvent): void => {
      if (event.target instanceof Node && !root.current?.contains(event.target)) cancelButton.current?.focus();
    };
    document.addEventListener('focusin', containFocus);
    return () => {
      document.removeEventListener('focusin', containFocus);
      document.body.style.overflow = previousOverflow;
      if (trigger instanceof HTMLElement) trigger.focus();
    };
  }, []);

  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (!pending) close();
    }
    if (event.key !== 'Tab') return;
    if (pending) {
      event.preventDefault();
      root.current?.focus();
      return;
    }
    if (event.shiftKey && document.activeElement === cancelButton.current) {
      event.preventDefault();
      confirmButton.current?.focus();
    }
    if (!event.shiftKey && document.activeElement === confirmButton.current) {
      event.preventDefault();
      cancelButton.current?.focus();
    }
  };

  return (
    <div className="admin-modal" role="dialog" aria-modal="true" aria-label="Запустить генерацию карты?" aria-describedby="generation-confirm-description" ref={root} tabIndex={-1} onKeyDown={onKeyDown}>
      <div className="admin-modal__panel map-generations__dialog">
        <h2>Запустить генерацию карты?</h2>
        <p id="generation-confirm-description">
          {replay ? 'Будет повторён запрос с тем же ключом. Уже принятый запуск не будет создан повторно.' : 'Будут подготовлены и опубликованы тайлы по текущим границам. Это может занять время. До подтверждения публикации используется прежняя карта.'}
        </p>
        <div className="map-generations__controls">
          <button className="workspace-secondary-button" type="button" ref={cancelButton} disabled={pending} onClick={close}>
            Отмена
          </button>
          <button className="admin-submit" type="button" ref={confirmButton} disabled={pending} onClick={confirm}>
            {pending ? 'Подтверждение…' : 'Подтвердить запуск'}
          </button>
        </div>
      </div>
    </div>
  );
}
